export const getShouldAlertOnLeave = state => state['navigation'].alertOnLeave

export const getAlertMessage = state => state['navigation'].message
